import React from "react";

const MyContext = React.createContext({
  state: {},
  setState: () => {},
});

export default MyContext;
